var render = function render(){var _vm=this,_c=_vm._self._c;return _c('profile-section',{attrs:{"section-title":"Activate Purchase"}},_vm._l((_vm.unrealizedPurchases),function(pr){return _c('span',{key:pr.id},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.activatePurchase(pr.id)}}},[_vm._v("\n      Activate "+_vm._s(_vm.purchaseOrderName(pr.purchaseOrderId))+"\n    ")]),_c('br')])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }